module.exports = __webpack_public_path__ + "img/bg-diamond.4d5e3e6.png";